import { Box } from '@factorialco/deprecated-design-system'

import WorkingConditionsVersionDetailsSection from 'modules/contracts_settings/components/WorkConditions/WorkingConditionVersionDetailsSection'
import { useWorkConditionsItemsStructure } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'

const WorkingConditionsVersionDetails = () => {
  const workingConditionsVersionSections = useWorkConditionsItemsStructure().map((section) =>
    WorkingConditionsVersionDetailsSection(section)
  )

  return (
    <Box flexGrow width="full">
      {workingConditionsVersionSections}
    </Box>
  )
}

export default WorkingConditionsVersionDetails
